import { Language } from "../../models/language";

export type LanguageString = keyof typeof Language;
interface TimeLabel { singular: string, plural: string };

export const TimeLabelMap: {[lang in LanguageString]: { 's': TimeLabel, 'm': TimeLabel, 'h': TimeLabel }} = {
    'en': {
        's': { singular: 'sec', plural: 'sec' },
        'm': { singular: 'min', plural: 'min' },
        'h': { singular: 'hr', plural: 'hrs' }
    },
    'da': {
        's': { singular: 'sek', plural: 'sek' },
        'm': { singular: 'min', plural: 'min' },
        'h': { singular: 't', plural: 't' }
    },
    'sv': {
        's': { singular: 'sek', plural: 'sek' },
        'm': { singular: 'min', plural: 'min' },
        'h': { singular: 'tim', plural: 'tim' }
    },
    'no': {
        's': { singular: 'sek', plural: 'sek' },
        'm': { singular: 'min', plural: 'min' },
        'h': { singular: 'time', plural: 'timer' }
    },
    'es': {
        's': { singular: 'seg', plural: 'seg' },
        'm': { singular: 'min', plural: 'min' },
        'h': { singular: 'h', plural: 'h' }
    },
    'fr': {
        's': { singular: 'sec', plural: 'sec' },
        'm': { singular: 'min', plural: 'min' },
        'h': { singular: 'h', plural: 'h' }
    },
    'de': {
        's': { singular: 'Sek', plural: 'Sek' },
        'm': { singular: 'Min', plural: 'Min' },
        'h': { singular: 'Std', plural: 'Std' }
    },
    'it': {
        's': { singular: 'sec', plural: 'sec' },
        'm': { singular: 'min', plural: 'min' },
        'h': { singular: 'ora', plural: 'ore' }
    },
    'ro': {
        's': { singular: 'sec', plural: 'sec' },
        'm': { singular: 'min', plural: 'min' },
        'h': { singular: 'oră', plural: 'ore' }
    },
    'nl': {
        's': { singular: 'seconde', plural: 'seconden' },
        'm': { singular: 'minuut', plural: 'minuten' },
        'h': { singular: 'uur', plural: 'uren' }
    },
}
